import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import RadioGroupPattern from '@mlb/react-patterns/components/RadioGroup/radioGroup';
import { Label } from '@mlb/react-patterns/components/RadioGroup/radioGroup.style';

import FilterHeader from '../FilterHeader';
import TypeaheadInput from '../TypeaheadInput';

const RadioGroup = styled(RadioGroupPattern)`
    width: 100%;
    break-inside: avoid;
`;

export const Modifiers = styled.div`
    display: flex;

    ${({ hasMultiple, theme }) => hasMultiple
        ? `
            column-count: 2;
            column-gap: ${theme.filter?.columnGap};
        `
        : `
            column-count: 1;

            ${RadioGroup} {
                column-count: 2;
                column-gap: ${theme.filter?.columnGap};

                ${Label} {
                    display: inline-flex;
                    width: 100%;
                }
            }
        `
};
`;

const Opponent = (props) => {

    const {
        header,
        suggestionsKey,
        placeholder,
        typeaheadFieldId,
        selected,
        className,
        disabled,
        disabledHeader,
        disabledTypeahead,
        onChange,
        onTypeaheadChange,
        state,
        modifiers,
        excludeId,
    } = props;

    return (
        <div className={className}>
            <FilterHeader text={header} disabled={disabledHeader} />
            <TypeaheadInput
                suggestionsKey={suggestionsKey}
                placeholder={placeholder}
                typeaheadFieldId={typeaheadFieldId}
                selected={selected}
                onChange={onTypeaheadChange}
                excludeId={excludeId}
                disabled={disabledTypeahead}
            />
            <Modifiers hasMultiple={Object.keys(modifiers).length > 1}>
                {Object.keys(modifiers).map(modifier =>
                    <RadioGroup
                        key={modifier}
                        name={`${header}_${modifier}`}
                        data={modifiers[modifier]}
                        checked={state[modifier].value}
                        handlers={{
                            onChange: (event) => onChange(event, modifier),
                        }}
                        disabled={disabled}
                    />
                )}
            </Modifiers>
        </div>
    );

};

Opponent.propTypes = {
    suggestionsKey: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    typeaheadFieldId: PropTypes.number.isRequired,
    disabled: PropTypes.bool.isRequired,
    header: PropTypes.string.isRequired,
    modifiers: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onTypeaheadChange: PropTypes.func.isRequired,
    state: PropTypes.object.isRequired,
    className: PropTypes.string,
    disabledHeader: PropTypes.bool,
    disabledTypeahead: PropTypes.bool,
    selected: PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
    }),
    excludeId: PropTypes.string,
};

Opponent.defaultProps = {
    className: undefined,
    disabledHeader: undefined,
    disabledTypeahead: undefined,
    selected: undefined,
    excludeId: undefined,
};

export default Opponent;
